import {isEmpty} from './tools';

class savePassClass {
    password: string;
    static _instance = {} as savePassClass;

    constructor() {
        this.password = '';
    }

    setPassword(password: string) {
        this.password = password;
    }

    getPassword() {
        return this.password;
    }

    removePassword() {
        this.password = '';
    }
}

export function getSavePassHandler(): savePassClass {
    if (!savePassClass._instance || isEmpty(savePassClass._instance)) {
        savePassClass._instance = new savePassClass();
    }
    return savePassClass._instance;
}
